import React from 'react';
import styles from './NexsetsTable.module.scss';
import { columns } from './columns';
import { Table } from 'new/elements/Table';
import { useMyNexsets } from 'new/hooks/adapters/useMyNexsets';
import { useDrawerContext } from 'new/components/drawer/useDrawerContext';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_DATA_SETS_REQUEST } from 'js/constants/actionTypes';
import { Nexset } from 'new/entities/Nexset';
import { useHistory } from 'react-router-dom';
import { NexsetDetail } from 'new/components/discover/NexsetDetail';
import { router } from 'new/routes/router';
import DataSetDetailActionsContainer from 'js/components/data_sets/cards/DataSetDetailActionsContainer';

interface NexsetsTableProps {
  orgId?: number;
  shared?: 'from' | 'to';
  height?: number;
  disableClick?: boolean;
}

export function NexsetsTable(props: NexsetsTableProps) {
  const { orgId, shared, disableClick } = props;
  const history = useHistory();
  const nexsets = useMyNexsets({ shared, orgId });
  const { drawerContentRef } = useDrawerContext();
  const loading = useIsLoading(GET_DATA_SETS_REQUEST);

  const onRowClicked = (row: Nexset) => {
    if (!disableClick) {
      history.push(
        router.manager.getPath(NexsetDetail.screenConfig.screenName, 'discover', [row.id]),
      );
    }
  };

  const getRowClass = (row) => {
    const classname = styles.rowWrapper;
    return classname;
  };

  return (
    <Table
      loading={loading}
      parentScrollRef={props.height ? undefined : drawerContentRef}
      getRowClassName={getRowClass}
      height={props.height}
      rowEndRender={(row) => {
        if (!row) {
          return null;
        }
        return (
          <DataSetDetailActionsContainer
            data={row}
            horizontalDots
            readOnly={row?.readOnly}
            showStatus={false}
            showTransform={false}
            showSend={false}
            isManaged={row?.isManaged}
            isDetected={row?.isDetected}
          />
        );
      }}
      onRowClick={!disableClick ? onRowClicked : undefined}
      columns={columns}
      rows={nexsets}
    />
  );
}
